import { Multilink } from '../../components/types/link.types';
import { DomService } from '../dom';
import { StringService } from '../string';

interface WindowWithVideo extends Window {
  onYouTubeIframeAPIReady?: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  YT?: any;
}

export enum VideoType {
  YOUTUBE = 'youtube',
}

export interface YoutubePlayer {
  playVideo: () => void;
  pauseVideo: () => void;
  seekTo: (_: number) => void;
  setSize: (_: number, __: number) => void;
}

export interface VideoOptions {
  videoId: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

const US_COOKIES = 'R0006';

const youtubeApi = 'https://www.youtube.com/iframe_api';

const isYoutubeAdded = (): boolean => !!document.querySelectorAll(`script[src="${youtubeApi}"]`).length;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isPrerender = !!(window as any).isPrerender;

export const VideoService = {
  async init(type: VideoType): Promise<void> {
    return new Promise((resolve) => {
      if (isPrerender) {
        resolve();
      }

      if (type === VideoType.YOUTUBE && !isYoutubeAdded()) {
        (window as WindowWithVideo).onYouTubeIframeAPIReady = () => resolve();
        document.head.appendChild(DomService.createElement('script', '', { src: youtubeApi }));
      } else {
        resolve();
      }
    });
  },

  async createPlayer(element: HTMLElement, options: VideoOptions): Promise<YoutubePlayer> {
    if (isPrerender) {
      return Promise.resolve(null);
    }

    await VideoService.init(VideoType.YOUTUBE);
    return new (window as WindowWithVideo).YT.Player(element, options);
  },

  getYoutubeVideoId(link: string | Multilink) {
    const parsedVideoLink: Multilink | string = StringService.stringToObject(link);
    const videoSrc = typeof parsedVideoLink === 'string' ? parsedVideoLink : parsedVideoLink?.src;

    if (videoSrc === '/') return null;

    if (videoSrc.includes('https')) {
      // macthes on the youtube video id, for embeded, normal and short link
      const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\\&v=)([^#\\&\\?]*).*/;
      const match = videoSrc.match(regExp);

      return match[2];
    }

    return videoSrc;
  },

  isUSCookieAccepted() {
    return !window.OnetrustActiveGroups ? false : window.OnetrustActiveGroups.includes(US_COOKIES);
  },

  acceptUSCookie() {
    window.OneTrust.UpdateConsent('Category', US_COOKIES.concat(':1'));
  },
};
